import { useContext } from "react"
import { useVideoDimensions } from "~/utils/useVideoDimensions"
import { SingleContext } from "~/contexts/SingleContext"
import { MultiContext } from "~/contexts/MultiContext"

export function YTLiveChat() {
  const { videoData, position, focused } = useContext(SingleContext)
  const { controlsEnabled } = useContext(MultiContext)
  const { videoId } = videoData
  const origDimensions = useVideoDimensions(position, focused)
  const videoDimensions = controlsEnabled
    ? { height: origDimensions.height - 48, width: (origDimensions.height - 48) * (16 / 9) }
    : origDimensions

  return (
    <iframe
      title="Live Chat"
      width={videoDimensions.width}
      height={videoDimensions.height}
      src={`https://www.youtube.com/live_chat?v=${videoId}&embed_domain=${window.location.hostname}`}
    ></iframe>
  )
}
